export default __webpack_public_path__ + "static/media/bg6.1669adc3.png";